import { render, staticRenderFns } from "./wordmouthPage.vue?vue&type=template&id=2dcaeeb0&scoped=true"
import script from "./wordmouthPage.vue?vue&type=script&lang=js"
export * from "./wordmouthPage.vue?vue&type=script&lang=js"
import style0 from "./wordmouthPage.vue?vue&type=style&index=0&id=2dcaeeb0&prod&lang=css"
import style1 from "./wordmouthPage.vue?vue&type=style&index=1&id=2dcaeeb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcaeeb0",
  null
  
)

export default component.exports